import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetPackageProviderPlansQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	packages?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;

export type GetPackageProviderPlansQuery = {
	__typename?: 'Query';
	packages: Array<{
		__typename?: 'Package';
		id: string;
		clearName: string;
		planOffers: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	}>;
};

export const GetPackageProviderPlansDocument = gql`
	query GetPackageProviderPlans($country: Country!, $language: Language!, $packages: [String!]) {
		packages(country: $country, platform: WEB, packages: $packages) {
			id
			clearName
			planOffers(country: $country, platform: WEB) {
				title
				retailPrice(language: $language)
				isTrial
				durationDays
				retailPriceValue
				children {
					title
					retailPrice(language: $language)
					isTrial
					durationDays
					retailPriceValue
				}
			}
		}
	}
`;
